import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCreateTeamMutation, useUpdateTeamsMutation } from '../../../services/EndPointsApis';
import TextField from '../../../core/common/textFields/TextField';
import { useFormik } from 'formik';
import { toast } from "react-toastify";
import * as Yup from "yup";
import Select, { StylesConfig } from "react-select";
import { useSelector } from 'react-redux';

const SidebarTeams = ({ activityTogglePopup, closeSidebar, isEditing, data, viewOnly }: any) => {
    const [updateId, setUpdateId] = useState(0);
    const [createTeam, { data: createTeamData, isError, error, isSuccess, isLoading }] = useCreateTeamMutation();
    const [UpdateTeam, { data: UpdateData, isError: UpdateIsError, error: UpdateError, isSuccess: UpdateIsSuccess }] = useUpdateTeamsMutation();
    const getdefaultLookups = useSelector((state: any) => state.auth.apiData);

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };

    const initialValues = {
        id: 0,
        name: "",
        description: "",
        status: true,
        lst_Site: {
            id: 0,
            value: ""
        },
        lst_Region: {
            id: 0,
            value: ""
        },
    };
    const TeamSchema = Yup.object().shape({
        name: Yup.string()
            .required("Name is required"),
        lst_Site: Yup.object().shape({
            id: Yup.number().required('Site id is required'),
            value: Yup.string().required('Site Value is required'),
        }),
        lst_Region: Yup.object().shape({
            id: Yup.number().required('Region id is required'),
            value: Yup.string().required('Region Value is required'),
        }),
    })
    const formik = useFormik({
        validationSchema: TeamSchema,
        initialValues,
        onSubmit: (values) => {
            if (isEditing) {
                UpdateTeam(values);
            } else {
                createTeam(values);
            }
        },
    });

    const { resetForm } = formik;

    const handleChangestatus = (e: any) => {
        const value = e.target.value === 'true';
        formik.setFieldValue('status', value);
    };
    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            setUpdateId(data?.id);
            formik.setValues({ ...data });
        } else {
            setUpdateId(0)
            resetForm();
        }
    }, [data]);

    useEffect(() => {
        if (isSuccess) {
            toast.success(createTeamData?.message);
            closeSidebar();
            resetForm();
        }
        else if (UpdateIsSuccess && isEditing) {
            toast.success(UpdateData?.message);
            closeSidebar();
            // resetForm();
        }
    }, [isSuccess, UpdateIsSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
        if (UpdateIsError && UpdateError) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in UpdateError && UpdateError.data && typeof UpdateError.data === 'object' && 'message' in UpdateError.data) {
                errorMessage = (UpdateError.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error, UpdateError, UpdateIsError]);

    useEffect(() => {
        if (!activityTogglePopup && !isEditing) {
            resetForm();
        }
    }, [activityTogglePopup]);

    return (
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <form onSubmit={formik.handleSubmit}>
                    <div className="sidebar-header">
                        <h4>{isEditing ? "Edit Team" : viewOnly === true ? 'View Team' : "Add Team"} </h4>
                        <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                            <i className="ti ti-x" />
                        </Link>
                    </div>
                    <div className="toggle-body">
                        <div className="toggle-height">
                            <div className="pro-create">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-wrap">
                                            <TextField
                                                label=" Team Name"
                                                required
                                                type="text"
                                                {...formik.getFieldProps("name")}
                                                disabled={viewOnly}
                                            />
                                        </div>
                                        {formik.touched.name && formik.errors.name && (
                                            <div className="error">{formik.errors.name}</div>
                                        )}
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <div className="form-wrap">
                                            <label className="input-label">
                                                Description
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows={4}
                                                {...formik.getFieldProps("description")}
                                                disabled={viewOnly}

                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-wrap">
                                            <label className="input-label">
                                                Site <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={getdefaultLookups?.result?.Lst_Site?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                                value={
                                                    formik.values?.lst_Site?.id
                                                        ? {
                                                            value: formik.values?.lst_Site?.id,
                                                            label: formik.values?.lst_Site?.value || '',
                                                        }
                                                        : []
                                                }
                                                isDisabled={viewOnly}
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue('lst_Site.id', selectedOption.value);
                                                    formik.setFieldValue('lst_Site.value', selectedOption.label);
                                                }}
                                            />
                                        </div>
                                        {formik.touched.lst_Site && formik.errors.lst_Site && (
                                            <div className="error">{formik.errors.lst_Site?.value}</div>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-wrap">
                                            <label className="input-label">
                                                Region <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={getdefaultLookups?.result?.Lst_Region?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                                value={
                                                    formik.values?.lst_Region?.id
                                                        ? {
                                                            value: formik.values?.lst_Region?.id,
                                                            label: formik.values?.lst_Region?.value || '',
                                                        }
                                                        : []
                                                }
                                                isDisabled={viewOnly}
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue('lst_Region.id', selectedOption.value);
                                                    formik.setFieldValue('lst_Region.value', selectedOption.label);
                                                }}
                                            />
                                        </div>
                                        {formik.touched.lst_Region && formik.errors.lst_Region && (
                                            <div className="error">{formik.errors.lst_Region?.value}</div>
                                        )}
                                    </div>
                                    <div className="col-md-12 d-flex align-items-center">
                                        <div className="radio-wrap">
                                            <label className="input-label">Status</label>
                                            <div className="d-flex flex-wrap">
                                                <div className="radio-btn">
                                                    <input
                                                        type="radio"
                                                        className="status-radio"
                                                        id="Active"
                                                        name="status"
                                                        value="true"
                                                        checked={formik.values.status === true}
                                                        onChange={handleChangestatus}
                                                        disabled={viewOnly}

                                                    />
                                                    <label htmlFor="Active">Active</label>
                                                </div>
                                                <div className="radio-btn">
                                                    <input
                                                        type="radio"
                                                        className="status-radio"
                                                        id="inActive"
                                                        name="status"
                                                        value="false"
                                                        checked={formik.values.status === false}
                                                        onChange={handleChangestatus}
                                                        disabled={viewOnly}

                                                    />
                                                    <label htmlFor="inActive">Inactive</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-button text-end">
                                <button className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                    Cancel
                                </button>
                                {viewOnly ? (<>

                                </>) : (<>
                                    <button
                                        className="btn btn-primary"
                                        type='submit'
                                    >
                                        {isEditing ? "Update" : "Add"}
                                    </button>
                                </>)}

                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SidebarTeams;
